import _ from "lodash";
import client from "lib/apolloClient/client";
import { PARENT, STAFF, STUDENT } from "Constants/stringConstants";
import { messageFragment, userFragment } from "./MessagingFragments";
import {
  getChatConversationsQuery,
  getChatDetailsQuery,
  getMessageV2UsersQuery,
  getCourseUsersQuery,
  getGradeUsersQuery,
  getOrganizationCourseUsersQuery,
  getCourseUsersQueryV2,
  getOrganizationCourseUsersQueryV2,
  getYearGroupUsersQuery,
  getMessageV2UsersWithStudentParentQuery,
  getGradeUsersQueryV2,
  getStaffRnpFilterCoursesCountQuery,
  getSearchedMembersInChatQuery,
  getDepartmentsQuery,
} from "./MessagingQuery";

const CACHE_TYPE_NAMES = {
  [STAFF]: "Staff",
  [STUDENT]: "Student",
  [PARENT]: "FamilyMember",
};

export const getCacheTypenameByUserType = userType =>
  _.get(CACHE_TYPE_NAMES, userType);

export const readMessageFromCache = ({ messageId, organizationId }) => {
  try {
    return client.readFragment({
      id: `MessageV2:${messageId}`,
      fragment: messageFragment.messageV2ItemDetail,
      fragmentName: "messageV2ItemDetail",
      variables: { organizationId },
    });
  } catch (err) {
    return {};
  }
};

export const writeMessageToCache = ({ messageId, data, organizationId }) => {
  try {
    return client.writeFragment({
      id: `MessageV2:${messageId}`,
      fragment: messageFragment.messageV2ItemDetail,
      fragmentName: "messageV2ItemDetail",
      variables: { organizationId },
      data,
    });
  } catch (err) {}
};

export const getChatDetailsFromCache = chatDetailsVariables => {
  try {
    const queryData = client.readQuery({
      query: getChatDetailsQuery,
      variables: chatDetailsVariables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const writeChatDetailsToCache = ({ variables, data }) => {
  try {
    client.writeQuery({
      query: getChatDetailsQuery,
      variables,
      data: { node: data },
    });
  } catch (e) {
    return {};
  }
};

export const getChatConversationsFromCache = chatConversationsVariables => {
  try {
    const queryData = client.readQuery({
      query: getChatConversationsQuery,
      variables: chatConversationsVariables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const writeChatConversationsToCache = ({
  variables,
  chatConversationsData,
}) => {
  try {
    client.writeQuery({
      query: getChatConversationsQuery,
      variables,
      data: { node: chatConversationsData },
    });
  } catch (e) {}
};

export const getMessageV2UsersFromCache = messageV2UsersVariables => {
  try {
    const queryData = client.readQuery({
      query: getMessageV2UsersQuery,
      variables: messageV2UsersVariables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getCourseUsersFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getCourseUsersQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getGradeUsersFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getGradeUsersQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getOrganizationCourseUsersFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getOrganizationCourseUsersQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

// helpers for messaging add members v3

export const getOrganizationCourseUsersFromCacheV2 = variables => {
  try {
    const queryData = client.readQuery({
      query: getOrganizationCourseUsersQueryV2,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getCourseUsersFromCacheV2 = variables => {
  try {
    const queryData = client.readQuery({
      query: getCourseUsersQueryV2,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getYearGroupUsersFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getYearGroupUsersQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getGradeUsersV2FromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getGradeUsersQueryV2,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getMessageV2UsersWithStudentParentFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getMessageV2UsersWithStudentParentQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getSearchedMembersInChatFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getSearchedMembersInChatQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getStaffRnpFilterCoursesCountFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getStaffRnpFilterCoursesCountQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getDepartmentsFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getDepartmentsQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const writeDepartmentDetailsToCache = ({ variables, data }) => {
  try {
    client.writeQuery({
      query: getDepartmentsQuery,
      variables,
      data: { node: data },
    });
  } catch (e) {}
};

export const getUserViewOnlyFromCache = ({ id, chatId, userType }) => {
  try {
    const userTypeName = getCacheTypenameByUserType(userType);
    return client.readFragment({
      id: `${userTypeName}:${id}`,
      fragment: userFragment.userChatViewOnly,
      fragmentName: "userChatViewOnly",
      variables: {
        chatId,
      },
    });
  } catch (e) {
    return {};
  }
};

export const writeUserViewOnlyToCache = ({ id, chatId, userType, data }) => {
  try {
    const userTypeName = getCacheTypenameByUserType(userType);

    client.writeFragment({
      id: `${userTypeName}:${id}`,
      fragment: userFragment.userChatViewOnly,
      fragmentName: "userChatViewOnly",
      variables: {
        chatId,
      },
      data,
    });
  } catch (e) {}
};
